import TokenRefresher from '@shared/components/loading/TokenRefresher';
import { ENABLED_REFRESH_TOKEN_STORE } from '@shared/constants/Keys';
import { subscribe } from '@shared/hooks/helpers/EventCallback';
import { mergeParamsToUrl } from '@shared/hooks/helpers/QueryString';
import { useAuthStore } from '@shared/hooks/state/AuthContainer';
import { useNotificationStore } from '@shared/hooks/state/NotificationContainer';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import AdminSidebarLayout from './layout/AdminSidebarLayout';

interface IProtectedRouteProps {
    authRedirect?: string;
    children?: React.ReactNode;
}

// TODO ADMIN PANEL: Update with  view Transitions
// TODO ADMIN PANEL: Update to use session storage or cookies for token so we can have expiration date.

export default function ProtectedLayout({ authRedirect = '../login', children }: IProtectedRouteProps) {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
    const isInitialized = useAuthStore((state) => state.isInitialized);
    const { getNewToken } = useAuthStore.getState();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const tokenRefresh = localStorage.getItem(ENABLED_REFRESH_TOKEN_STORE);
    const { initializeFromRemote: initializeNotifications } = useNotificationStore.getState();

    useEffect(() => {
        if (!isAuthenticated && tokenRefresh && !isInitialized) {
            getNewToken();
        } else if (searchParams.get('code')) {
            navigate(`../authcallback?code=${searchParams.get('code')}`, { replace: true, viewTransition: true });
        } else if (!isAuthenticated) {
            navigate(authRedirect, { replace: true, viewTransition: true });
        }

        const unsubNavigateTo = subscribe('navigateTo', (data) => {
            if (data.path) {
                const url = data.params ? mergeParamsToUrl(data.path, data.params) : data.path;
                navigate(url, { replace: false, viewTransition: true });
            }
        });
        return () => {
            unsubNavigateTo();
        };
    }, []);

    useEffect(() => {
        if (!isInitialized) return;

        initializeNotifications();
        const intervalId = setInterval(
            () => {
                initializeNotifications();
            },
            30 * 60 * 1000
        ); // 30 minutes in milliseconds

        return () => clearInterval(intervalId);
    }, [isInitialized]);

    if (!isInitialized || !isAuthenticated) {
        return null;
    }

    return (
        <>
            <TokenRefresher />
            <AdminSidebarLayout />
        </>
    );
}
